export const socialLinks = {
  x: {
    label: 'X',
    handle: '@TheMindvrik',
    href: 'https://x.com/TheMindvrik',
  },
  linkedin: {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/amit-kumar-787387426',
  },
  instagram: {
    label: 'Instagram',
    handle: '@themindvrik_1234',
    href: 'https://www.instagram.com/themindvrik_1234/',
  },
};
